// Config for marketing consent toggle on sign up
export const marketingConsentActivated = false;
// Brand privacy url to be added
export const brandPrivacyPolicyUrl = '';
